const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Obtener usuarios con filtros y paginación
 */
export const fetchUsers = async ({ limit = 50, offset = 1, query = {} } = {}) => {
  try {
    const response = await fetch(`${API_URL}/user/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los usuarios');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los usuarios:', error);
    throw error;
  }
};

/**
 * Crear un nuevo usuario
 */
export const createUser = async (userData) => {
  try {
    const response = await fetch(`${API_URL}/user/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el usuario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el usuario:', error);
    throw error;
  }
};

/**
 * Actualizar un usuario existente
 */
export const updateUser = async (id, userData) => {
  try {
    const response = await fetch(`${API_URL}/user/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: userData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el usuario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el usuario:', error);
    throw error;
  }
};

/**
 * Eliminar un usuario
 */
export const deleteUser = async (id) => {
  try {
    const response = await fetch(`${API_URL}/user/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el usuario');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el usuario:', error);
    throw error;
  }
};

/**
 * Asignar edificios a un usuario
 */
export const assignEdificiosToUser = async (userId, edificioIds) => {
  try {
    const response = await fetch(`${API_URL}/user/assign-edificios`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, edificioIds }),
    });

    if (!response.ok) {
      throw new Error('Error al asignar portafolios');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al asignar portafolios:', error);
    throw error;
  }
};

/**
 * Obtener edificios asignados a un usuario
 */
export const getEdificiosAsignados = async (userId) => {
  try {
    const response = await fetch(`${API_URL}/user/${userId}/edificios-asignados`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener portafolios asignados');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener portafolios asignados:', error);
    throw error;
  }
};

/**
 * Exportar usuarios
 */
export const exportUsers = async (query = {}) => {
  try {
    const response = await fetch(`${API_URL}/user/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(query),
    });

    if (!response.ok) {
      throw new Error('Error al exportar usuarios');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al exportar usuarios:', error);
    throw error;
  }
};
